import { render, staticRenderFns } from "./PracticeNote.vue?vue&type=template&id=590e2a68&scoped=true&"
import script from "./PracticeNote.vue?vue&type=script&lang=js&"
export * from "./PracticeNote.vue?vue&type=script&lang=js&"
import style0 from "./PracticeNote.vue?vue&type=style&index=0&id=590e2a68&scoped=true&lang=css&"
import style1 from "./PracticeNote.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e2a68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VDialog,VTextarea})
